import { ReactNode } from 'react';

export const TableSubComponentWrapper = ({
  children,
  colSpan,
}: {
  children?: ReactNode;
  colSpan?: number;
}) => {
  return (
    <tr>
      <td colSpan={colSpan}>{children}</td>
    </tr>
  );
};
